class VacationModel {
  public id: number = 0;
  public description: string = "";
  public destination: string = "";
  public image: string = "vacation-bg.jpg";
  public start: any = "";
  public finish: any = "";
  public price: number = 0;
  public followers: number = 0;
  public follower_id: number = 0;
  public prevImgName: string = "";
}

export default VacationModel;
